import { ContactFeatures, TContactCardTheme } from '@cian/contact-card-component';
import * as React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { EBrandingLevel } from '../../../../node/repositories/offer-card/v1/get-offer-data';
import { AgencyBrandingAsideCard, AgencyLabels } from '../../../components/AgencyBrandingAsideCard';
import {
  selectAgencyFeatures,
  selectAgencyName,
  selectBrandingLevel,
  selectIsMortgageBlockAvailable,
  selectIsHonestIconsShow,
  selectIsOfferPageRedesign,
} from '../../../selectors';
import { getMasterOrSelfAvatar, getMasterOrSelfLink } from '../../../selectors/agentSelectors';
import { selectIsSubAgent } from '../../../selectors/offerData/agent';
import { isCommercialSelector } from '../../../selectors/offerData/offer/isCommercialSelector';
import { selectIsAgencyBrandingAvailable } from '../../../selectors/offerData/selectIsAgencyBrandingAvailable';
import { trackAgencyBrandingCardClick } from '../../../utils/analytics';
import { useApplicationContext } from '../../ApplicationContext';
import { selectHasVerifiedDocuments } from '../../ApprovalContainer/selectors/selectHasVerifiedDocuments';
import { MortgageSidebarBannerContainer } from '../../MortgageSidebarBannerContainer';
import { AgencyBrandingAgentCardContainer } from '../AgencyBrandingAgentCard';
import { AgencyBrandingIconsContainer } from '../AgencyBrandingIcons';

export const AgencyBrandingAsideCardContainer = () => {
  const { config } = useApplicationContext();
  const isSubAgent = useSelector(selectIsSubAgent, shallowEqual);
  const brandingLevel = useSelector(selectBrandingLevel);
  const agencyFeatures = useSelector(selectAgencyFeatures, shallowEqual);
  const agencyName = useSelector(selectAgencyName);
  const isAgencyHonestIconsShow = useSelector(selectIsHonestIconsShow);
  const agencyLink = useSelector(getMasterOrSelfLink);
  const agencyAvatar = useSelector(getMasterOrSelfAvatar);
  const hasVerifiedDocuments = useSelector(selectHasVerifiedDocuments);
  const isBrandingAvailable = useSelector(selectIsAgencyBrandingAvailable);
  const isCommercialOffer = useSelector(isCommercialSelector);
  const isShowMortgage = useSelector(selectIsMortgageBlockAvailable);
  const isRedesigned = useSelector(selectIsOfferPageRedesign);

  const isBannerEnabled = config.get<boolean>('mortgage.sidebarBannerEnabled');

  const isMortgageBlockAvailable = !!isBannerEnabled && isShowMortgage && !isCommercialOffer && !isRedesigned;

  const handleAgencyNameClick = React.useCallback(() => {
    trackAgencyBrandingCardClick('name');
  }, []);

  if (!isBrandingAvailable) {
    return null;
  }

  const theme: TContactCardTheme = brandingLevel === EBrandingLevel.ThirdLevel ? 'premium' : 'default';

  return (
    <AgencyBrandingAsideCard
      theme={theme}
      agencyAvatar={agencyAvatar}
      onAgencyNameClick={handleAgencyNameClick}
      agencyName={agencyName}
      agencyLink={agencyLink || ''}
      agencyIconsElement={isAgencyHonestIconsShow && <AgencyBrandingIconsContainer />}
      agencyLabels={hasVerifiedDocuments && <AgencyLabels />}
      agencyFeaturesElement={!!agencyFeatures.length && <ContactFeatures features={agencyFeatures} />}
      agentElement={isSubAgent && <AgencyBrandingAgentCardContainer />}
      mortgage={isMortgageBlockAvailable && <MortgageSidebarBannerContainer />}
    />
  );
};
